<template>
  <div class="fieldset">
    <h3 class="fieldset-heading">Children</h3>
    <ChildrenYN
        v-model="form.children_have"
        :children="form.children"
        :number-of-children="form.profileChildrenNumber"
        @numberOfChildren="form.profileChildrenNumber=$event"
    />
    <div v-if="form.children_have" class="question-box with-arrow">
      <ChildrenFull
          v-model="form.children"
          @refresh="refresh"
          :number-of-children="form.profileChildrenNumber"
          @numberOfChildren="form.profileChildrenNumber=$event"
          ref="childrenFull"
      />
    </div>
    <Pregnant v-model="form.profilePregnant"/>
    <div v-if="form.profilePregnant" class="question-box with-arrow">
      <PregnantDate v-model="form.profilePregnantDueDate"/>
    </div>

    <h3 class="fieldset-heading">Dependants</h3>
    <DependantsYN
        v-model="form.dependants_have"
        :dependants="form.dependants"
        :number-of-dependants="form.profileDependantsNumber"
        @numberOfDependants="form.profileDependantsNumber=$event"
    />
    <div v-if="form.dependants_have" class="question-box with-arrow">
      <DependantsFull
          v-model="form.dependants"
          :number-of-dependants="form.profileDependantsNumber"
          @numberOfDependants="form.profileDependantsNumber=$event"
          @refresh="refresh"
          ref="dependantsFull"
      />
    </div>
  </div>
</template>

<script>
import {fieldsetHelpers} from "../fieldsetHelpers";

import ChildrenYN from "../../question/questions/clientProfile/people/ChildrenYN";
import ChildrenFull from "../../question/questions/clientProfile/people/ChildrenFull";
import DependantsYN from "../../question/questions/clientProfile/people/DependantsYN";
import DependantsFull from "../../question/questions/clientProfile/people/DependantsFull";
import Pregnant from "../../question/questions/clientProfile/people/Pregnant";
import PregnantDate from "../../question/questions/clientProfile/people/PregnantDate";

export default {
  name: 'ChildrenDependantsFull',
  mixins: [fieldsetHelpers],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    PregnantDate,
    Pregnant,
    DependantsFull,
    DependantsYN,
    ChildrenFull,
    ChildrenYN

  },
  data() {
    return {
      label: 'Dependants' // used for steps progress
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  },
  methods: {
    refresh() {
      if ('childrenFull' in this.$refs && this.$refs.childrenFull) {
        this.$refs.childrenFull.get()
      }
      if ('dependantsFull' in this.$refs && this.$refs.dependantsFull) {
        this.$refs.dependantsFull.get()
      }
    }
  }
};
</script>
